import React, { Component } from 'react'
import { Home as HomeIcon } from 'react-feather'

import BreadcrumbCard from '../utils/BreadcrumbCard'
import Directory from './Directory'

import '../App.css'

class Home extends Component {
    static getTitle() {
        return <span className="whitespace-nowrap inline-flex items-center gap-1"><HomeIcon className={ 'icon-text-inline' } /> Home</span>
    }
    static getSearchTitle() {
        return "Home"
    }
    static getLink() {
        return "/"
    }
    static getTags() {
        return [
            "home",
            "directory",
        ]
    }

    render() {
        const breadcrumbs = [
            {
                title: Home.getTitle(),
                href: "/",
                active: true,
            }
        ]

        return (
            <BreadcrumbCard breadcrumbs={ breadcrumbs } id={ "home" } isHome={ true }>
                <Directory />
            </BreadcrumbCard>
        )
    }
}

export default Home
